<!-- Modals -->
<ui-dialog
    [open]="currentlyOpenDialog === 'ADD_EMAIL'"
    [form]="addEmailForm.form"
    size="small"
    (primaryButtonPressed)="onAddEmail(addEmailForm)"
    primaryButtonLabel="save"
    (secondaryButtonPressed)="onCancel()"
    (closing)="onCancel()"
    secondaryButtonLabel="cancel"
    header="employees.account.addEmail"
>
    <app-form-email #addEmailForm></app-form-email>
</ui-dialog>

<ui-confirmation-dialog
    #confirmDeleteEmail
    header="employees.account.deleteEmail"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
>
    {{ 'employees.account.areYouSureYouWantToDeleteThisEmail' | translate }}
</ui-confirmation-dialog>

<ui-confirmation-dialog
    #confirmMakePrimary
    header="employees.account.setThisEmailAsYourPrimaryEmail"
    primaryButtonLabel="account.makePrimary"
    secondaryButtonLabel="cancel"
>
    {{ 'employees.account.bySettingThisEmailAsThePrimaryEmail' | translate }}
</ui-confirmation-dialog>

<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header
        title="{{ 'employees.account.employeeProfile' | translate }}"
        [employee]="employee"
        (isLoading)="isLoading = $event"
    ></app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>
        <div class="content">
            <ui-card class="account-actions" *ngIf="showAccountInformation">
                <app-segment-header title="{{ 'employees.account.accountSettings' | translate }}"></app-segment-header>

                @if (canLoginAs) {
                    <div class="flex">
                        <!-- Login As -->
                        <ui-button type="link" (click)="addPendoTrackingForClickSignInAsEmployee(); signInAs()">
                            <mat-icon svgIcon="login" />{{
                                'employees.account.signInAsEmployee' | translate: { fullName: employee.fullName }
                            }}
                        </ui-button>
                        @if (isKYCKYBFlagEnabled) {
                            <ui-tip>
                                {{
                                    'employees.account.signInAsTip.message' | translate: { fullName: employee.fullName }
                                }}
                                <a
                                    target="__blank"
                                    href="{{ 'employees.account.signInAsTip.learnMoreURL' | translate }}"
                                >
                                    {{ 'employees.account.signInAsTip.learnMore' | translate }}</a
                                >
                            </ui-tip>
                        }
                    </div>
                }

                <!-- Lock/Unlock -->
                <ng-container *ngIf="!employeeIsTerminated">
                    <ui-button type="ghost" *permission="updateAccountPermission" (click)="changeLock()">
                        <ng-container *ngIf="account.isLocked">
                            <mat-icon svgIcon="unlock" />{{
                                'employees.account.unlockEmployeeAccount'
                                    | translate
                                        : {
                                              firstName: employee.firstName,
                                          }
                            }}
                        </ng-container>

                        <ng-container *ngIf="!account.isLocked">
                            <mat-icon svgIcon="lock" />{{
                                'employees.account.lockEmployeeAccount'
                                    | translate
                                        : {
                                              firstName: employee.firstName,
                                          }
                            }}
                        </ng-container>
                    </ui-button>
                </ng-container>

                <ui-button type="ghost" *ngIf="activationLink" (click)="copyActivationLink()">
                    <mat-icon svgIcon="copy" />
                    {{ 'employees.account.copyActivationLink' | translate }}
                </ui-button>
            </ui-card>

            <ui-card *ngIf="emailsTable" class="emails-table" [withSpacing]="false">
                <app-table
                    (menuItemSelected)="menuAction($event)"
                    [isResponsive]="true"
                    [showOffset]="true"
                    [noPadding]="true"
                    [embedded]="true"
                    [showSearch]="false"
                    [useStickyHeader]="false"
                    [table]="emailsTable"
                    title="{{ 'account.emails' | translate }}"
                >
                </app-table>
                <ui-button
                    *permission="updateAccountPermission"
                    class="add-email-button"
                    type="link"
                    (click)="currentlyOpenDialog = 'ADD_EMAIL'"
                    >&#43; {{ 'account.addNewEmail' | translate }}</ui-button
                >
            </ui-card>
        </div>
    </div>
</div>
